import ExpenseAttachedItemRepository from '@/shared/http/repositories/business/expenseattacheditem.js'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'CollapseImageComissionItens',
  props: ['data', 'dataAnexos', 'dataDetails'],
  data () {
    return {
      angel: false
    }
  },
  computed: {
    getFilesAnexos: function () {
      if (this.dataAnexos.length > 0) {
        return this.dataAnexos.filter((Element) => Element.despesaItemID === this.data.id)
      }
      return []
    }
  },
  methods: {
    inputOpen () {
      document.getElementById('input-' + this.data.id).click()
    },
    onDragEnter (e) {
      e.target.children[0].style.color = 'white'
      e.target.style.background = '#00552d'
    },
    onDragLeave (e) {
      e.target.style.background = 'white'
      e.target.children[0].style.color = 'black'
    },
    sendFile (e) {
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let files = []
      if (e.target.files === undefined) {
        e.target.style.background = 'white'
        e.target.children[0].style.color = 'black'
        files = e.dataTransfer.files
      } else {
        files = e.target.files
      }
      let file = new FormData()
      for (let i = 0; i < files.length; i++) {
        file.append('file', files[i])
      }
      loading.push()
      ExpenseAttachedItemRepository.SendFiles(this.data.id, file, conf)
        .then(Response => {
          loading.pop()
          this.$emit('ReloadImg')
        })
        .catch(Error => {
          loading.pop()
        })
    },
    deleteFile (id) {
      loading.push()
      ExpenseAttachedItemRepository.DeleteFile(id)
        .then(Response => {
          loading.pop()
          this.$emit('ReloadImg')
        })
        .catch(Error => loading.pop())
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/CollapseImageComissionItens/CollapseImageComissionItens.js